import _request from '@/utils/request.js'

var _menu = {
    // 查询所有菜单和权限的树形结构
    getMenuTreeList (isSystem, parentId, resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getMenuTreeList"),
            params  : {
                isSystem: isSystem,
                parentId: parentId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据角色标识查询菜单结构				
    getMenuTreeListByRoleId (roleId, resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getMenuTreeListByRoleId"),
            params  : {
                roleId: roleId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据角色标识查询菜单结构				
    getPowerIdsByRoleId (roleId, resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getPowerIdsByRoleId"),
            params  : {
                roleId: roleId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据角色标识查询菜单结构				
    getPowerTreeListForManage (parentId, resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getPowerTreeListForManage"),
            params  : {
                parentId: parentId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据菜单获取操作
    getOperationsByPowerId (resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getMenuPowerMapByUserId"),
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 获取所有系统级别菜单
    getSystemMenuForManage (resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/power/getSystemMenuForManage"),
            method  : 'get',
            success : resolve,
            error   : reject
        })
    }
}

export default _menu